/* 最近閲覧した商品（bspt-recently-viewed セクション）。
   閲覧履歴（商品ID）を localStorage に保存し、Section Rendering API で
   検索コンテキスト（q=id:... OR id:...）のカードHTMLを取得して差し込む。
   カード描画は Liquid 側（限定商品の出し分けを通すため）。 */
(function () {
  var STORAGE_KEY = 'bspt_recently_viewed';
  var MAX_ITEMS = 8;

  function readHistory() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!Array.isArray(raw)) return [];
      return raw.filter(function (id) {
        return /^\d+$/.test(String(id));
      }).map(String);
    } catch (e) {
      return [];
    }
  }

  function saveCurrent(id) {
    try {
      var history = readHistory().filter(function (saved) {
        return saved !== id;
      });
      history.unshift(id);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(0, MAX_ITEMS)));
    } catch (e) {
      /* localStorage 不可の環境では保存しない */
    }
  }

  class BsptRecentlyViewed extends HTMLElement {
    connectedCallback() {
      var currentId = String(this.dataset.productId || '');
      var limit = parseInt(this.dataset.limit, 10) || 4;
      var ids = readHistory().filter(function (id) {
        return id !== currentId;
      }).slice(0, limit);

      if (currentId) saveCurrent(currentId);
      if (ids.length === 0) return;

      var query = ids.map(function (id) {
        return 'id:' + id;
      }).join(' OR ');
      var url = this.dataset.searchUrl +
        '?section_id=' + this.dataset.sectionName +
        '&type=product&q=' + encodeURIComponent(query);

      var element = this;
      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('recently viewed fetch failed: ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = doc.querySelector('[data-bspt-recently-viewed-grid]');
          if (!grid) return;

          /* 検索結果は履歴順で返らないので、履歴順（新しい順）に並べ替える */
          ids.forEach(function (id) {
            var item = grid.querySelector('li[data-product-id="' + id + '"]');
            if (item) grid.appendChild(item);
          });

          if (grid.querySelectorAll('li').length === 0) return;
          element.querySelector('[data-bspt-recently-viewed-slot]').appendChild(grid);
          element.removeAttribute('hidden');
        })
        .catch(function () {
          /* 取得失敗時は非表示のまま */
        });
    }
  }

  if (!customElements.get('bspt-recently-viewed')) {
    customElements.define('bspt-recently-viewed', BsptRecentlyViewed);
  }
})();
